/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Verify_Email_LabelInputs */

const en_onboarding_verify_email_label = /** @type {(inputs: Onboarding_Verify_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`University email`)
};

const de_onboarding_verify_email_label = /** @type {(inputs: Onboarding_Verify_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Universitäts-E-Mail`)
};

const fr_onboarding_verify_email_label = /** @type {(inputs: Onboarding_Verify_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail universitaire`)
};

const es_onboarding_verify_email_label = /** @type {(inputs: Onboarding_Verify_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correo universitario`)
};

const it_onboarding_verify_email_label = /** @type {(inputs: Onboarding_Verify_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email universitaria`)
};

const nl_onboarding_verify_email_label = /** @type {(inputs: Onboarding_Verify_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Universiteits-e-mail`)
};

const pl_onboarding_verify_email_label = /** @type {(inputs: Onboarding_Verify_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail uniwersytecki`)
};

const fi_onboarding_verify_email_label = /** @type {(inputs: Onboarding_Verify_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yliopiston sähköposti`)
};

const da_onboarding_verify_email_label = /** @type {(inputs: Onboarding_Verify_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Universitetsmail`)
};

const sv_onboarding_verify_email_label = /** @type {(inputs: Onboarding_Verify_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Universitetsmejl`)
};

/**
* | output |
* | --- |
* | "University email" |
*
* @param {Onboarding_Verify_Email_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const onboarding_verify_email_label = /** @type {((inputs?: Onboarding_Verify_Email_LabelInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Verify_Email_LabelInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_onboarding_verify_email_label(inputs)
	if (locale === "fr") return fr_onboarding_verify_email_label(inputs)
	if (locale === "es") return es_onboarding_verify_email_label(inputs)
	if (locale === "it") return it_onboarding_verify_email_label(inputs)
	if (locale === "nl") return nl_onboarding_verify_email_label(inputs)
	if (locale === "pl") return pl_onboarding_verify_email_label(inputs)
	if (locale === "fi") return fi_onboarding_verify_email_label(inputs)
	if (locale === "da") return da_onboarding_verify_email_label(inputs)
	if (locale === "sv") return sv_onboarding_verify_email_label(inputs)
	return en_onboarding_verify_email_label(inputs)
});